import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import PageHelmet from '@bd/bdcore-pagehelmet';
import withData from '@bd/bdcore-data';
import PageWrapper from '../../components/PageWrapper';
import HeroVideo from '../../components/HeroVideo';
import ShowcaseSections from './ShowcaseSections';
import WelcomeText from './WelcomeText';
import ContactBanner from '../../components/ContactBanner';

function Index({ page }) {
  return (
    <PageWrapper headerAltState>
      <PageHelmet page={page} />
      <HeroVideo
        background={_.get(page, 'page_image.contentUrl')}
        video={_.get(page, 'header_video.contentUrl')}
        title={_.get(page, 'hero_image_text[0]title')}
        subtitle={_.get(page, 'hero_image_text[0]subtitle')}
      />
      <WelcomeText section={_.get(page, 'welcome_text[0]', {})} />
      <ShowcaseSections page={page} />
      <ContactBanner />
    </PageWrapper>
  );
}

Index.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData(
  {
    page: 'home_page',
  },
)(Index);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/index.js